import styles from "./AppDayButton.module.scss";

import React, { type ButtonHTMLAttributes } from "react";

import { CalendarDay, Modifiers } from "react-day-picker";

export function AppDayButton(
  props: {
    day: CalendarDay;
    modifiers: Modifiers;
  } & ButtonHTMLAttributes<HTMLButtonElement>,
) {
  const { day, modifiers, className, disabled, ...buttonProps } = props;

  const ref = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    if (modifiers.focused || modifiers.selected) ref.current?.focus();
  }, [modifiers.focused, modifiers.selected]);

  return (
    <button
      ref={ref}
      disabled={disabled}
      {...buttonProps}
      className={`${className} ${styles.day} ${modifiers.today ? styles.today : ""} ${!disabled ? styles.enabled : ""} ${modifiers.selected ? styles.selected : ""}`}
    >
      <span>{day.date.getDate()}</span>
      {modifiers.today && (
        <span data-testid="today-dot" className={styles.dot} />
      )}
    </button>
  );
}
